import * as React from "react"
import { Typography } from "@mui/material"


export default function reportTypeColumn() {
	return [{
        name: "reportType", label: 'Report Type',
		options: {
			display:"excluded",
			customBodyRowRenderLite: (value) => <Typography>
				{value}
			</Typography>
		}
    }, {
		name: "reportType", label: 'Report Type',
		options: {
            filter: false,
			customBodyRowRenderLite: (value) => <Typography sx={{ textAlign: 'center'}}>
                {value}
            </Typography>
		}
	}]
}